import PricingCalculator from './PricingCalculator';

export default function App() {
  return <PricingCalculator />;
}
